import React from 'react';
import dayjs from "dayjs";

import {CircularProgress, Stack} from "@mui/joy";
import Typography from "@mui/joy/Typography";
import Card from "@mui/joy/Card";

// components
import BaseApi from "../../utils/BaseApi";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import { customRange} from "../../utils/misc";
import CommonForm from "../Common/CommonForm";
import CalculatorItem from "../Calculator/CalculatorItem";
import {colors} from "../Calculator/Calculator";
import LaborReportTaskModal from "./LaborReportTaskModal";
import LaborReportYearChart from "./LaborReportYearChart";


dayjs.locale('ru');


class UserLaborReport extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            forecastRevenues: null,
            xtypesChoices: null,
            overallReport: null,
            ready: false,
            userForReport: null,
            users: null,
        }
    }

    async componentDidMount() {
        await this.retrieveData();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            this.setState({
                userForReport: null,
            });
        }
    }

    async buildOverallReport(userForReport, employeeForReport){
        const api = new BaseApi();
        let overallReport = {
            monthes: [],
            total: {
                capacity: 0,
                payRoll: 0,
                phase: 0,
                opportunity: 0,
                noOpportunity: 0,
                lostCapacity: 0,
                overload: 0,
            }
        };
        let employeeReport = this.props.employeeReport
        let url = this.props.calculatorURL;
        let params = {
            year_end: this.props.year,
            year_start: this.props.year,
            model: 'TaskDailyDuration',
            period:	"month",
            field: '',
            date_field: '',
            groups: [],
            custom_date_field: 'date',
            custom_field: 'duration_fact',
        }
        params.queryset_params = JSON.stringify({
            "active": "True",
            "task__phase__isnull": "False",
            "task__executor__id": userForReport,
        })
        let response = await api.post(
            url,
            params
        );
        let phaseTasksReport = response.data
        params.custom_field = 'duration_plan'
        response = await api.post(
            url,
            params
        );
        let phaseTasksReportPlan = response.data
        params.custom_field = 'duration_fact'
        params.queryset_params = JSON.stringify({
            "active": "True",
            "task__phase__isnull": "True",
            "task__opportunity__isnull": "False",
            "task__executor__id": userForReport,
        })
        response = await api.post(
            url,
            params
        );
        let opportunityTasksReport = response.data
        params.custom_field = 'duration_plan'
        response = await api.post(
            url,
            params
        );
        let opportunityTasksReportPlan = response.data
        params.custom_field = 'duration_fact'
        params.queryset_params = JSON.stringify({
            "active": "True",
            "task__phase__isnull": "True",
            "task__opportunity__isnull": "True",
            "task__executor__id": userForReport,
        })
        response = await api.post(
            url,
            params
        );
        let noOpportunityTasksReport = response.data
        params.custom_field = 'duration_plan'
        response = await api.post(
            url,
            params
        );
        let noOpportunityTasksReportPlan = response.data
        for (let month of customRange(1,12,1)){
            let monthReport = {
                month: month,
                capacity: employeeReport.employees[employeeForReport].salaries[this.props.year][month].workdays_with_occupation * 8,
                capacity_sixtyfive: employeeReport.employees[employeeForReport].salaries[this.props.year][month].workdays_with_occupation * 8 * 0.715,
                capacity_thirtyfive: employeeReport.employees[employeeForReport].salaries[this.props.year][month].workdays_with_occupation * 8 * 0.285,
                overload: 0,
                payRoll: employeeReport.employees[employeeForReport].salaries[this.props.year][month].salary_with_occupation,
                phase: phaseTasksReport.stats[this.props.year]?phaseTasksReport.stats[this.props.year][month].duration_fact:0,
                opportunity: opportunityTasksReport.stats[this.props.year]?opportunityTasksReport.stats[this.props.year][month].duration_fact:0,
                noOpportunity: noOpportunityTasksReport.stats[this.props.year]?noOpportunityTasksReport.stats[this.props.year][month].duration_fact:0,
                phasePlan: phaseTasksReportPlan.stats[this.props.year]?phaseTasksReportPlan.stats[this.props.year][month].duration_plan:0,
                opportunityPlan: opportunityTasksReportPlan.stats[this.props.year]?opportunityTasksReportPlan.stats[this.props.year][month].duration_plan:0,
                noOpportunityPlan: noOpportunityTasksReportPlan.stats[this.props.year]?noOpportunityTasksReportPlan.stats[this.props.year][month].duration_plan:0,
                lostCapacity: 0,
            }
            if (month <= (new Date).getMonth() && this.props.year === (new Date).getFullYear() || this.props.year < (new Date).getFullYear()) {
                let lostCapacity = monthReport.capacity - monthReport.phase - monthReport.opportunity - monthReport.noOpportunity
                if (lostCapacity > 0){
                    monthReport.lostCapacity = lostCapacity
                }
                else {
                    monthReport.overload = -lostCapacity
                }
            }
            overallReport.total.lostCapacity += monthReport.lostCapacity
            overallReport.total.overload += monthReport.overload
            overallReport.total.capacity += monthReport.capacity
            overallReport.total.payRoll += monthReport.payRoll
            overallReport.total.phase += monthReport.phase
            overallReport.total.opportunity += monthReport.opportunity
            overallReport.total.noOpportunity += monthReport.noOpportunity
            overallReport.monthes.push(monthReport)
        }
        return overallReport
    }

    async retrieveData() {
        const api = new BaseApi();
        let url = 'user/';
        let response = await api.get(
            url,
            {}
        )
        let users = [];
        for (let user of response.data.results) {
            users.push({
                value: user.id,
                label: `${user.first_name} ${user.last_name}`
            })
        }
        this.setState({
            users: users,
            ready: true,
        });
    }

    async applyUser(form) {
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );
        let overallReport
        const api = new BaseApi();
        let url = `user/${formDataObj.user}/`;
        let response = await api.get(
            url,
            {}
        )
        if (response.data?.subscriber){
            url = `subscriber/${response.data.subscriber}/`;
            response = await api.get(
                url,
                {}
            )
            if (response.data?.employee){
                overallReport = await this.buildOverallReport(
                    formDataObj.user,
                    response.data.employee
                )
            }
        }

        this.setState({
            userForReport: formDataObj.user,
            overallReport: overallReport,
        })
    }

    render() {
        if (!this.state.ready) {
            return (
                <CircularProgress/>
            )
        }
        let yearColors = {}
        yearColors[this.props.year] = '#1f77b4'
        return (
            <Stack
                spacing={2}
                sx={{
                    width: '100%',
                }}
            >
                <Typography
                    level={'h4'}
                >
                    Анализ сотрудника
                </Typography>
                <CommonForm
                    processForm={this.applyUser.bind(this)}
                    fields={[
                        {
                            'name': 'user',
                            'label': 'Пользователь',
                            'xs': 12,
                            'sm': null,
                            'md': 6,
                            'lg': null,
                            'xl': null,
                            'required': false,
                            'default': null,
                            'type': 'select',
                            'options': this.state.users,
                        },
                        {
                            'type': 'submit',
                            'label': 'Применить'
                        }
                    ]}
                />
                {
                    this.state.userForReport?
                        <Stack
                            spacing={2}
                        >
                            {
                                this.state.overallReport?
                                    <LaborReportYearChart
                                        overallReport={this.state.overallReport}
                                    />:
                                    null
                            }
                            <Stack
                                direction={'row'}
                                spacing={2}
                            >
                                <Card
                                    sx={{
                                        maxWidth: '50%',
                                    }}
                                >
                                    <Typography
                                        level={'h6'}
                                    >
                                        Задачи в трудоемкостях
                                    </Typography>
                                    <LaborReportTaskModal
                                        key={crypto.randomUUID()}
                                        label={'Открыть список'}
                                        executor={{id: this.state.userForReport}}
                                        noPhase={false}
                                        noOpportunity={false}
                                    />
                                    <CalculatorItem
                                        key={crypto.randomUUID()}
                                        calculatorURL={this.props.calculatorURL}
                                        item={{
                                            year_end: this.props.year,
                                            year_start: this.props.year,
                                            model: 'TaskDailyDuration',
                                            period:	"month",
                                            field: '',
                                            date_field: '',
                                            charts: [{"years":[this.props.year],
                                                "dataset": "default",
                                                "colorMode": "list",
                                                "yearColors": yearColors,
                                                "datasetValue": "N/A",
                                                "currentCategory": "duration_fact"
                                            }],
                                            groupsConfig: {
                                                "task.account": {
                                                    "year": this.props.year,
                                                    "legendIsHidden": false,
                                                    "currentCategory": "duration_fact"
                                                },
                                                "task.opportunity": {
                                                    "year": this.props.year,
                                                    "legendIsHidden": false,
                                                    "currentCategory": "duration_fact"
                                                }
                                            },
                                            groups: JSON.stringify([
                                                'task.opportunity',
                                                'task.account',
                                            ]),
                                            size: 12,
                                            custom_date_field: 'date',
                                            custom_field: 'duration_fact',
                                            queryset_params: JSON.stringify({
                                                "active": "True",
                                                "task__executor__id": this.state.userForReport,
                                                "task__phase__isnull": "False",
                                            }),
                                        }}
                                        updateItemCallBack={() => {}}
                                        colors={colors}
                                    />
                                </Card>
                                <Card
                                    sx={{
                                        maxWidth: '50%',
                                    }}
                                >
                                    <Typography
                                        level={'h6'}
                                    >
                                        Задачи вне трудоемкостей
                                    </Typography>
                                    <Stack
                                        direction={'row'}
                                        spacing={2}
                                    >
                                        <LaborReportTaskModal
                                            key={crypto.randomUUID()}
                                            label={'Открыть список со сделкой'}
                                            executor={{id: this.state.userForReport}}
                                            noPhase={true}
                                            noOpportunity={false}
                                        />
                                        <LaborReportTaskModal
                                            key={crypto.randomUUID()}
                                            label={'Открыть список без сделки'}
                                            executor={{id: this.state.userForReport}}
                                            noPhase={true}
                                            noOpportunity={true}
                                        />
                                    </Stack>
                                    <CalculatorItem
                                        key={crypto.randomUUID()}
                                        calculatorURL={this.props.calculatorURL}
                                        item={{
                                            year_end: this.props.year,
                                            year_start: this.props.year,
                                            model: 'TaskDailyDuration',
                                            period:	"month",
                                            field: '',
                                            date_field: '',
                                            charts: [{"years":[this.props.year],
                                                "dataset": "default",
                                                "colorMode": "list",
                                                "yearColors": yearColors,
                                                "datasetValue": "N/A",
                                                "currentCategory": "duration_fact"
                                            }],
                                            groupsConfig: {
                                                "task.account": {
                                                    "year": this.props.year,
                                                    "legendIsHidden": false,
                                                    "currentCategory": "duration_fact"
                                                },
                                                "task.opportunity": {
                                                    "year": this.props.year,
                                                    "legendIsHidden": false,
                                                    "currentCategory": "duration_fact"
                                                }
                                            },
                                            groups: JSON.stringify([
                                                'task.opportunity',
                                                'task.account',
                                            ]),
                                            size: 12,
                                            custom_date_field: 'date',
                                            custom_field: 'duration_fact',
                                            queryset_params: JSON.stringify({
                                                "active": "True",
                                                "task__executor__id": this.state.userForReport,
                                                "task__phase__isnull": "True",
                                            }),
                                        }}
                                        updateItemCallBack={() => {}}
                                        colors={colors}
                                    />
                                </Card>
                            </Stack>
                        </Stack>
                        :
                        null
                }
            </Stack>
        )
    }
}

export default UserLaborReport;